export default theme => ({
  root: {},
  alignRight: {
    align: 'right',
  },
  previewStopTableRow: {}
});

